export default function BankAccount(data) {
    let bankAccount = data || {};
    this.number = bankAccount.number;
    this.comment = bankAccount.comment;
    this.accountType = bankAccount.accountType;
    this.category = bankAccount.category;
    this.colNum = bankAccount.colNum;
}